// Copyright (c) 2020 Deere & Company

import {
    getAdditionalData,
    getAdditionalDataType,
    getAdditionalTestParameter,
    getRgaConsignment,
    getRgaDealerInfo,
    getRgaDetails,
    getRgaFiles,
    getRgaQandA,
    postRgaAdditionalDataValues,
    postRgaAnalysisValues,
    postRgaConsignmentValues,
    postRgaDealerInfoValues,
    resetProperties
} from '../../rga-search-results/action-creators/rga-details';
import {
    setRouteToDefaultTab,
    updateRgaConsignmentValues,
    updateRgaDealerInfoValues
} from './advance-returned-part-info-form';
import {
    setRouteToReturnPartDefaultTab,
    updateRgaAdditionalDataCommentsValues,
    updateRgaAdditionalDataTestValues,
    updateRgaAdditionalDataTypeValues,
    updateRgaAnalysisValues
} from './returned-part-info-form';
import {
    deleteFileRga
} from './delete-file';

export default {
    deleteFileRga,
    getAdditionalData,
    getAdditionalDataType,
    getAdditionalTestParameter,
    getRgaConsignment,
    getRgaDealerInfo,
    getRgaDetails,
    getRgaFiles,
    getRgaQandA,
    postRgaAdditionalDataValues,
    postRgaAnalysisValues,
    postRgaConsignmentValues,
    postRgaDealerInfoValues,
    resetProperties,
    setRouteToDefaultTab,
    setRouteToReturnPartDefaultTab,
    updateRgaAdditionalDataCommentsValues,
    updateRgaAdditionalDataTestValues,
    updateRgaAdditionalDataTypeValues,
    updateRgaAnalysisValues,
    updateRgaConsignmentValues,
    updateRgaDealerInfoValues
};



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/action-creators/index.js